import React, { useState } from "react";
import { Link } from "react-router-dom";

const IMAGE_CACHE = "question-images-v1";

const IMAGE_LIST = [
  "/image1/img1.png",
  "/image1/img2.png",
  "/image1/img3.png",
  "/image1/img4.png",
  "/image1/img5.png",
  "/image1/img6.png",

];

const DownloadImages = () => {
  const [downloaded, setDownloaded] = useState(0);
  const [downloading, setDownloading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [error, setError] = useState("");

  const downloadImages = async () => {
    setDownloading(true);
    setComplete(false);
    setError("");
    setDownloaded(0);

    try {
      const cache = await caches.open(IMAGE_CACHE);
      let count = 0;

      for (const imageUrl of IMAGE_LIST) {
        const alreadyCached = await cache.match(imageUrl);

        if (!alreadyCached) {
          const response = await fetch(imageUrl);

          if (!response.ok) {
            throw new Error(`Unable to download: ${imageUrl}`);
          }
          await cache.put(imageUrl, response.clone());
        }
        count++;
        setDownloaded(count);
      }

      setComplete(true);
    } catch (error) {
      console.error(error);
      setError("Unable to download all images. Please try again.");
    } finally {
      setDownloading(false);
    }
  };

  const percentage = IMAGE_LIST.length === 0 ? 0 : Math.round((downloaded / IMAGE_LIST.length) * 100);

  return (
    <div>
      <h1>Prepare Mock Test</h1>

      <p>Download the question images before starting the mock test.</p>

      <button onClick={downloadImages} disabled={downloading}>
        {downloading ? "Downloading..." : "Download Images"}
      </button>

      {downloading && (
        <div>
          <p>Downloading {downloaded} / {IMAGE_LIST.length}</p>
          <progress value={downloaded} max={IMAGE_LIST.length} />
          <p>{percentage}%</p>
        </div>
      )}

      {complete && (
        <div>
          <h3>✓ All images are ready</h3>
          <Link to="/view-images">View Images</Link>
        </div>
      )}
      <br></br><br></br>


      <Link to="/view-images">View Images</Link>


      <br></br><br></br> <br></br> <br></br>

      {error && <p>{error}</p>}
    </div>
  );
};

export default DownloadImages;